module.exports = __webpack_public_path__ + "static/media/supplier-is-not-homologated.ef0bd046.svg";